const mobileAccountQuery = '(max-width: 900px)';

const initAuthTabs = (root) => {
    const tablist = root.querySelector('[data-account-auth-tabs]');
    const tabs = [...root.querySelectorAll('[data-account-auth-tab]')];
    const panels = [...root.querySelectorAll('[data-account-auth-panel]')];

    if (!tablist || tabs.length < 2) {
        return;
    }

    const initialView = panels.find((panel) => !panel.hidden)?.dataset.accountAuthPanel || 'login';
    const notices = root.querySelector('.woocommerce-notices-wrapper');
    tablist.setAttribute('role', 'tablist');

    tabs.forEach((tab) => {
        tab.setAttribute('role', 'tab');
        tab.removeAttribute('aria-current');
    });
    panels.forEach((panel) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', `account-${panel.dataset.accountAuthPanel}-tab`);
    });

    const selectView = (view, updateUrl = true) => {
        tabs.forEach((tab) => {
            const selected = tab.dataset.accountAuthTab === view;
            tab.classList.toggle('is-active', selected);
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
        });
        panels.forEach((panel) => {
            panel.hidden = panel.dataset.accountAuthPanel !== view;
        });

        if (notices) {
            notices.hidden = view !== initialView;
        }

        if (updateUrl) {
            const url = new URL(window.location.href);
            if (view === 'register') {
                url.searchParams.set('account_view', 'register');
            } else {
                url.searchParams.delete('account_view');
            }
            window.history.replaceState(window.history.state, '', url);
        }
    };

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', (event) => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                return;
            }
            event.preventDefault();
            selectView(tab.dataset.accountAuthTab);
        });
        tab.addEventListener('keydown', (event) => {
            let nextIndex;
            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (event.key === ' ') nextIndex = index;
            if (nextIndex === undefined) return;

            event.preventDefault();
            selectView(tabs[nextIndex].dataset.accountAuthTab);
            tabs[nextIndex].focus();
        });
    });

    window.addEventListener('popstate', () => selectView(
        new URL(window.location.href).searchParams.get('account_view') === 'register' ? 'register' : 'login',
        false,
    ));
    selectView(initialView, false);
};

const centerActiveAccountTab = (root) => {
    if (!window.matchMedia(mobileAccountQuery).matches) {
        return;
    }

    const scroller = root.querySelector('.AccountNav__menu');
    const activeLink = scroller?.querySelector('a[aria-current="page"]');

    if (!scroller || !activeLink) {
        return;
    }

    const scrollerBounds = scroller.getBoundingClientRect();
    const activeBounds = activeLink.getBoundingClientRect();
    const target = scroller.scrollLeft
        + activeBounds.left
        - scrollerBounds.left
        - ((scrollerBounds.width - activeBounds.width) / 2);

    scroller.scrollTo({
        left: Math.max(0, target),
        behavior: 'auto',
    });
};

const revealFormFeedback = (root) => {
    const feedback = root.querySelector('.woocommerce-error, .woocommerce-message');

    if (!feedback) {
        return;
    }

    feedback.setAttribute('tabindex', '-1');

    window.requestAnimationFrame(() => {
        feedback.focus({ preventScroll: true });
        feedback.scrollIntoView({
            block: 'center',
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
                ? 'auto'
                : 'smooth',
        });
    });
};

export const initAccount = (root) => {
    if (!root || root.dataset.accountReady === 'true') {
        return;
    }

    const mobileQuery = window.matchMedia(mobileAccountQuery);
    const updateActiveTab = () => window.requestAnimationFrame(
        () => centerActiveAccountTab(root),
    );

    mobileQuery.addEventListener?.('change', updateActiveTab);
    initAuthTabs(root);
    updateActiveTab();
    revealFormFeedback(root);

    root.dataset.accountReady = 'true';
};
